import styled from "styled-components";

const StyledItemMarker = styled.div`
    width: 5px;
    background-color: ${(props) => props.$color};
    margin-right: 5px;
`;

export default StyledItemMarker;
